import { combineReducers } from 'redux';

import api from './api/reducer';
import chat from './chat/reducer';
import socket from './socket/reducer';
import trip from './trip/reducer';

const rootReducer = combineReducers({
  api,
  chat,
  socket,
  trip,
});

export default rootReducer;
